(() => {
  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties2) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties2));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute."
      );
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError(
        "Theme Sections: The properties object provided is not a valid"
      );
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties2) {
    if (typeof type !== "string") {
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error(
        'Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice'
      );
    }
    function TypedSection(container) {
      Section.call(this, container, properties2);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function(instance) {
            return instance.container === container;
          })
        );
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function(instance) {
            return instance.type === type;
          })
        );
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id2) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id2) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // node_modules/@shopify/theme-currency/currency.js
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // node_modules/@shopify/theme-cart/request.js
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        }
      })
    );
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cart() {
    return fetchJSON("/cart.js", getDefaultRequestConfig());
  }
  function cartAddFromForm(formData) {
    var config = getDefaultRequestConfig();
    delete config.headers["Content-Type"];
    config.method = "POST";
    config.body = formData;
    return fetchJSON("/cart/add.js", config);
  }
  function cartChange(line, options2) {
    var config = getDefaultRequestConfig();
    options2 = options2 || {};
    config.method = "POST";
    config.body = JSON.stringify({
      line,
      quantity: options2.quantity,
      properties: options2.properties
    });
    return fetchJSON("/cart/change.js", config);
  }

  // node_modules/@shopify/theme-cart/validate.js
  function key(key2) {
    if (typeof key2 !== "string" || key2.split(":").length !== 2) {
      throw new TypeError(
        "Theme Cart: Provided key value is not a string with the format xxx:xxx"
      );
    }
  }
  function quantity(quantity2) {
    if (typeof quantity2 !== "number" || isNaN(quantity2)) {
      throw new TypeError(
        "Theme Cart: An object which specifies a quantity or properties value is required"
      );
    }
  }
  function id(id2) {
    if (typeof id2 !== "number" || isNaN(id2)) {
      throw new TypeError("Theme Cart: Variant ID must be a number");
    }
  }
  function properties(properties2) {
    if (typeof properties2 !== "object") {
      throw new TypeError("Theme Cart: Properties must be an object");
    }
  }
  function form(form2) {
    if (!(form2 instanceof HTMLFormElement)) {
      throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement");
    }
  }
  function options(options2) {
    if (typeof options2 !== "object") {
      throw new TypeError("Theme Cart: Options must be an object");
    }
    if (typeof options2.quantity === "undefined" && typeof options2.properties === "undefined") {
      throw new Error(
        "Theme Cart: You muse define a value for quantity or properties"
      );
    }
    if (typeof options2.quantity !== "undefined") {
      quantity(options2.quantity);
    }
    if (typeof options2.properties !== "undefined") {
      properties(options2.properties);
    }
  }

  // node_modules/@shopify/theme-cart/theme-cart.js
  function getState() {
    return cart();
  }
  function getItemIndex(key2) {
    key(key2);
    return cart().then(function(state) {
      var index = -1;
      state.items.forEach(function(item, i) {
        index = item.key === key2 ? i + 1 : index;
      });
      if (index === -1) {
        return Promise.reject(
          new Error("Theme Cart: Unable to match line item with provided key")
        );
      }
      return index;
    });
  }
  function addItemFromForm(form2) {
    form(form2);
    var formData = new FormData(form2);
    id(parseInt(formData.get("id"), 10));
    return cartAddFromForm(formData);
  }
  function updateItem(key2, options2) {
    key(key2);
    options(options2);
    return getItemIndex(key2).then(function(line) {
      return cartChange(line, options2);
    });
  }

  // app/scripts/common/_currency.js
  var AT_Currency = {
    currenciesCallback: function() {
      if (theme.currency.type != "2") {
        return;
      }
      var shopCurrency = "", defaultCurrency = "", cookieCurrency = "";
      let self = this;
      theme.currency.currenciesCallback = () => {
        if (Currency == null || theme.currency == null) {
          return;
        }
        Currency.format = theme.currency.currency_format;
        shopCurrency = theme.currency.shopCurrency;
        let formCurrency = document.querySelector('select[name="currency"]');
        if (formCurrency.value != shopCurrency) {
          formCurrency.value = shopCurrency;
          formCurrency.dispatchEvent(new Event("change"));
          formCurrency.closest("form").submit();
        }
        Currency.money_with_currency_format[shopCurrency] = theme.currency.moneyFormatWithCurrency_strip;
        Currency.money_format[shopCurrency] = theme.currency.moneyFormat_strip;
        defaultCurrency = shopCurrency;
        cookieCurrency = Currency.cookie.read();
        let spanMoney = document.querySelectorAll("span.money");
        spanMoney.length && spanMoney.forEach((s) => {
          s.setAttribute(`data-currency-${shopCurrency}`, s.innerHTML);
        });
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
          } else {
            Currency.currentCurrency = defaultCurrency;
          }
          Currency.cookie.write(defaultCurrency);
        } else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        } else {
          typeof cookieCurrency == "undefined" && (cookieCurrency = defaultCurrency);
          Currency.convertAll(shopCurrency, cookieCurrency);
          Currency.convertAll(Currency.currentCurrency, cookieCurrency);
        }
        self.updateState();
      };
      theme.currency.currenciesCallbackSpecial = (id2) => {
        if ("undefined" == typeof Currency || "undefined" == typeof theme.currency) {
          return;
        }
        let target = document.querySelectorAll(id2);
        target.length && target.forEach((element) => {
          element.setAttribute(`data-currency-${shopCurrency}`, element.innerHTML);
        });
        Currency.convertAll(shopCurrency, Currency.cookie.read(), id2, theme.currency.currency_format);
      };
    },
    convert: function(id2) {
      if (theme.currency.type != "2" || !theme.currency || !theme.currency.currenciesCallbackSpecial) {
        return;
      }
      theme.currency.currenciesCallbackSpecial(id2);
    },
    updateState: function() {
      if (theme.currency.type != "2") {
        return;
      }
      let currentCurrency = _AC.getCookie("currency");
      let labelCurrency = document.querySelectorAll("[data-currency-code]");
      let btnCurrency = document.querySelectorAll(".btn-currency[data-value]");
      currentCurrency.includes(";") && (currentCurrency = currentCurrency.split(";")[0]);
      labelCurrency.length && labelCurrency.forEach((c) => {
        c.textContent = currentCurrency;
      });
      btnCurrency.length && btnCurrency.forEach((b) => {
        b.getAttribute("data-value") == currentCurrency ? b.classList.add("active") : b.classList.remove("active");
      });
    },
    initEvents: function() {
      let self = this;
      _AC.addEvent(document, "click", ".btn-currency", (e) => {
        e.preventDefault();
        let _this = e.target, value = _this.getAttribute("data-value");
        switch (theme.currency.type) {
          case "1":
            let formCurrency = document.querySelector("form.shopify-currency-form");
            if (formCurrency == null) {
              return;
            }
            let optionSelect = formCurrency.querySelector("select");
            optionSelect.value = value;
            optionSelect.dispatchEvent(new Event("change"));
            formCurrency.submit();
            break;
          case "2":
            typeof Currency != "undefined" && Currency.convertAll(Currency.currentCurrency, value);
            self.updateState();
            break;
          default:
        }
      });
      theme.currency.type == "2" && theme.currency.currenciesCallback();
    },
    init: function() {
      if (!theme.currency.enable) {
        return;
      }
      let self = this;
      self.currenciesCallback();
      self.initEvents();
    }
  };
  var currency_default = AT_Currency;

  // app/scripts/cart.js
  var currencyConvert = currency_default.convert;
  var AT_Main2 = theme.ac;
  var AT_Cart = {
    init: function() {
      this.initEvents();
    },
    initEvents: function() {
      let this2 = this;
      AT_Main2.addEvent(
        document,
        "change",
        "select.qty-select-change",
        function(e) {
          let this4 = e.target;
          let input = this4.closest("[data-item]").querySelector('input[name="updates[]"]');
          input.value = this4.value;
          this2.updateItemByKey(input);
        }
      );
      AT_Main2.addEvent(document, "click", "#addToCartBtn", function(e) {
        if (!document.getElementById("addToCartBtn").form.checkValidity() || !document.getElementById("cartAlert"))
          return;
        e.preventDefault();
        AT_Main2.triggerDialog(document.getElementById("cartAlert"));
      });
      AT_Main2.addEvent(document, "click", "#cartAlert .btn-continue", function(e) {
        if (document.getElementById("addToCartBtn").form.checkValidity())
          document.getElementById("addToCartBtn").form.submit();
      });
      AT_Main2.addEvent(document, "click", ".qty-select a", function(e) {
        e.preventDefault();
        let this4 = e.target, input = this4.closest(".qty-select").querySelector("input"), oldValue = +input.value, currentValue = +input.value, min = +input.getAttribute("min") || 0, max = +input.getAttribute("max") || null;
        if (input.hasAttribute("disabled"))
          return;
        if (this4.getAttribute("class").includes("plus")) {
          if (max != null && currentValue + 1 > max) {
            return;
          }
          currentValue++;
        } else {
          input.dataset.itemKey != null && (min = 0);
          currentValue > min && currentValue--;
        }
        input.value = currentValue;
        if (input.dataset.itemKey == null)
          return;
        if (this2.waitQuantityUpdate !== null) {
          clearTimeout(this2.waitQuantityUpdate);
        }
        this2.waitQuantityUpdate = setTimeout(function() {
          this2.updateItemByKey(input);
          this2.waitQuantityUpdate = null;
        }, 500);
      });
      AT_Main2.addEvent(document, "click", ".btn-discount", function(e) {
        e.preventDefault();
        let this4 = e.target;
        let code = this4.closest("div").querySelector('[name="discountcode"]').value;
        let url = this4.dataset.baseurl.replace("code", code);
        location.href = url;
      });
    },
    addToCart: function() {
      let this2 = this;
      let btn = this2.currentBtn;
      let form2 = btn.closest("form");
      if (form2 == null) {
        return;
      }
      addItemFromForm(form2).then((item) => {
        this2.currentBtn.classList.remove("loading");
        this2.getCartPopup();
        this2.updateCartCount();
      }).catch((e) => {
        this2.currentBtn.classList.remove("loading");
      });
    },
    getCartPopup: function() {
      let url = theme.routes.cart_url + "?section_id=static-cart";
      let existed = document.getElementById("popupAddCart");
      existed != null && existed.remove();
      document.body.classList.add("modal-loading");
      fetch(url).then((e) => e.text()).then((e) => {
        let dom = new DOMParser().parseFromString(e, "text/html");
        document.body.insertAdjacentElement(
          "beforeend",
          dom.querySelector(".shopify-section > *")
        );
        document.body.classList.remove("modal-loading");
        theme.ac.triggerDialog("popupAddCart");
      });
    },
    updateCartCount: function() {
      getState().then((cart2) => {
        let total = cart2.item_count;
        let cartCount = document.querySelectorAll("[data-cart-count]");
        cartCount.length && cartCount.forEach((i) => i.innerHTML = total);
      });
    },
    updateCartTotal: function(cart2) {
      let total = formatMoney(
        cart2.total_price,
        theme.currency.moneyFormat
      );
      let cartCount = document.querySelectorAll("[data-cart-total]");
      cartCount.length && cartCount.forEach((i) => i.innerHTML = total);
    },
    updateValue: function(container = document, selector, value) {
      let listTarget = container.querySelectorAll(selector);
      listTarget.length && listTarget.forEach((item) => {
        if (item.tagName == "SELECT") {
          item.value = value;
        } else {
          item.innerHTML = value;
        }
      });
    },
    updateItemByKey: function(input) {
      let this2 = this;
      let key2 = input.dataset.itemKey;
      let quantity2 = +input.value;
      let selectorEl = input.closest("[data-item]");
      updateItem(key2, { quantity: quantity2 }).then((cart2) => {
        this2.updateCartCount();
        this2.updateCartTotal(cart2);
        if (cart2.items.length) {
          if (quantity2 < 1 && selectorEl != null) {
            AT_Main2.fadeOut(selectorEl);
          }
          cart2.items.map((i) => {
            this2.updateLineItem(i);
          });
          this2.updateValue(
            document,
            "[data-cart-subtotal]",
            formatMoney(
              cart2.original_total_price,
              theme.currency.moneyFormat
            )
          );
        } else {
          fetch(theme.root_url + "?section_id=cart-template").then((e) => e.text()).then((e) => {
            let dom = new DOMParser().parseFromString(e, "text/html");
            document.body.querySelector(".cart-section").replaceWith(dom.querySelector(".cart-section"));
          });
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    updateLineItem: function(item) {
      let this2 = this;
      let selector = document.querySelectorAll(`[data-item-key="${item.key}"]`);
      if (!selector.length)
        return;
      selector.forEach((l) => {
        let container = l.closest("[data-item]");
        if (container == null)
          return;
        this2.updateValue(container, "[data-item-quantity]", item.quantity);
        this2.updateValue(
          container,
          "[data-item-total]",
          formatMoney(
            item.final_line_price,
            theme.currency.moneyFormat
          )
        );
      });
    }
  };
  AT_Cart.init();
  register("cart-recommend", {
    onLoad: function() {
      let container = this.container;
      let baseUrl = container.dataset.baseUrl;
      let limit = container.dataset.limit;
      let currentList = container.dataset.currentList.split("|");
      let listProductId = container.dataset.productList.split("|");
      if (container.dataset.type == "metafield") {
        theme.initSlider(container);
        return;
      }
      if (!listProductId.length)
        return;
      window.performance.mark(
        "debut:product:fetch_product_recommendations.start"
      );
      let promiseArray = [];
      listProductId.forEach((productId) => {
        promiseArray.push(
          new Promise((resolved, reject) => {
            let recommendationsSectionUrl = `${baseUrl}?section_id=product-list-recommendations&product_id=${productId}&limit=${limit}`;
            fetch(recommendationsSectionUrl + "&view=ajax").then((response) => response.text()).then(function(productHtml) {
              let b = document.createElement("div");
              b.innerHTML = productHtml;
              b.innerHTML = b.firstElementChild.innerHTML;
              resolved(b.innerHTML.trim());
              window.performance.mark(
                "debut:product:fetch_product_recommendations.end"
              );
              performance.measure(
                "debut:product:fetch_product_recommendations",
                "debut:product:fetch_product_recommendations.start",
                "debut:product:fetch_product_recommendations.end"
              );
            }).catch((e) => {
              console.log(e);
              reject("");
            });
          })
        );
      });
      Promise.all(promiseArray).then((resp) => {
        let listHandle = resp.join("|").split("|");
        listHandle = [...new Set(listHandle)];
        listHandle = listHandle.filter((i) => !currentList.includes(i));
        if (!listHandle.length)
          return;
        let productHTML = [];
        listHandle.forEach((handle) => {
          handle = handle.replace(`<!--shopify:rendered_by_section_api-->`, "").trim();
          productHTML.push(
            new Promise((resolved, reject) => {
              let url = theme.routes.cart_url.replace("cart", "products") + "/" + handle + "?section_id=call-product-section";
              fetch(url).then((e) => e.text()).then((e) => {
                let d = document.createElement("div");
                d.innerHTML = e;
                d.innerHTML = d.firstElementChild.innerHTML;
                resolved(d.innerHTML.trim());
              }).catch((e) => {
                console.log(e);
                reject("");
              });
            })
          );
        });
        Promise.all(productHTML).then((resp2) => {
          let content = container.querySelector(".recommendations-content");
          let contentHTML = content.innerHTML;
          contentHTML += resp2.join("");
          content.innerHTML = contentHTML;
          container.style.visibility = null;
          theme.initSlider(container);
        });
      });
    }
  });
  load("*");

  // app/scripts/home.js
  register("slideshow", {
    onLoad: function() {
      let container = this.container;
      let config = container.querySelector('[name="sectionSlideConfig"]');
      let slide = container.querySelector(".slide_ui-element");
      if (!theme.slider || config == null || slide == null) {
        return;
      }
      let controls = JSON.parse(config.dataset.nav || false), nav = JSON.parse(config.dataset.dot || false), loop = JSON.parse(config.dataset.loop || false), autoplay = +config.dataset.autoplay > 0 ? true : false, autoplayTimeout = +config.dataset.autoplay || 0, items = config.dataset.items.split(","), gutters = (config.dataset.gutters ? config.dataset.gutters.replace(/[a-zA-Z]/g, "") : "0").split(","), itemClass = config.dataset.itemClass;
      slide.classList.remove("row", "d-grid");
      let responsive = {
        0: { items: +items[5], gutter: +gutters[5] },
        375: { items: +items[4], gutter: +gutters[4] },
        576: { items: +items[3], gutter: +gutters[3] },
        768: { items: +items[2], gutter: +gutters[2] },
        992: { items: +items[1], gutter: +gutters[1] },
        1200: { items: +items[0], gutter: +gutters[0] }
      };
      itemClass.length && [...slide.children].forEach((child) => {
        child.className = itemClass;
      });
      let tnsConfig = {
        container: slide,
        items: items[5],
        gutter: gutters[5],
        startIndex: 0,
        loop,
        controls,
        controlsPosition: "bottom",
        controlsContainer: container.querySelector(".slide_ui-controls--nav"),
        nav,
        navPosition: "bottom",
        mouseDrag: true,
        autoplay,
        autoplayTimeout,
        responsive,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        onInit: () => {
          if (container.querySelector(".tns-nav") != null) {
            container.querySelector(".tns-nav").classList.add("slide_ui-controls", "slide_ui-controls--dot");
          }
        }
      };
      this.slider = theme.slider(tnsConfig);
    },
    onBlockSelect: function(e) {
      this.slider.goTo(+e.target.dataset.index);
    },
    onBlockDeselect: function(e) {
      this.slider.goTo(0);
    }
  });
  if (theme.initSlider) {
    register("featured-product", {
      onLoad: function() {
        theme.initSlider(this.container);
      }
    });
    register("featured-blog", {
      onLoad: function() {
        theme.initSlider(this.container);
      }
    });
    register("gallery-slide", {
      onLoad: function() {
        theme.initSlider(this.container);
      }
    });
    register("categories", {
      onLoad: function() {
        theme.initSlider(this.container);
      }
    });
    register("customer-review", {
      onLoad: function() {
        theme.initSlider(this.container);
      }
    });
  }
  load("*");

  // app/scripts/page.js
  register("contact-page", {
    onLoad: function() {
    }
  });
  load("*");

  // app/scripts/main-theme.js
  register("video-slide", {
    onLoad: function() {
      theme.initSlider(this.container);
      let videoModal = this.container.querySelector("#modal-video");
      let openVideoButtons = this.container.querySelectorAll(".js-btn-open-video");
      let iframe = videoModal.querySelector("iframe");
      let closeButtons = this.container.querySelectorAll("[data-dialog-close]");
      openVideoButtons.forEach((button) => {
        let url = "https://www.youtube.com/embed/" + button.dataset.ytbId + "?autoplay=1";
        button.addEventListener("click", () => {
          iframe.src = url;
          AT_Main.triggerDialog(videoModal, "show");
        });
      });
      closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
          iframe.src = "";
        });
      });
    }
  });
  register("brand-logo", {
    onLoad: function() {
      theme.initSlider(this.container);
    }
  });
  load("*");
})();
